export default "__VITE_ASSET__08c0e32e__"